import React from 'react';
import { FaUserTimes, FaTwitch, FaSpotify } from 'react-icons/fa';
import { HOME_TEXTS } from './constants';
import '../../styles/Home.css';

/**
 * Props pour le composant DisconnectedStatusCard
 * @typedef {Object} DisconnectedStatusCardProps
 * @property {Function} onLogin - Fonction appelée lors du clic sur un bouton de connexion
 */

/**
 * Composant de carte de statut pour un utilisateur non connecté
 * Affiche un message d'invitation et des boutons de connexion rapide
 *
 * @component
 * @param {DisconnectedStatusCardProps} props - Les props du composant
 * @returns {JSX.Element} La carte de statut déconnecté
 */
const DisconnectedStatusCard = ({ onLogin }) => {
  const handleLogin = () => {
    try {
      onLogin();
    } catch (error) {
      console.error('Erreur lors de l\'ouverture de la modal de connexion:', error);
    }
  };

  return (
    <div className="connection-status-card disconnected">
      <div className="disconnected-status-glow" aria-hidden />
      <div className="disconnected-status-content">
        <div className="disconnected-status-leading">
          <div className="status-icon-wrapper disconnected-status-icon">
            <FaUserTimes className="status-icon" aria-hidden />
          </div>
          <div className="status-info disconnected-status-info">
            <span className="disconnected-status-kicker">Session</span>
            <span className="status-label">{HOME_TEXTS.DISCONNECTED}</span>
            <p className="status-hint">{HOME_TEXTS.DISCONNECT_HINT}</p>
          </div>
        </div>
        <div
          className="disconnected-status-separator"
          role="separator"
          aria-hidden
        />
        <div className="quick-login-buttons disconnected-status-actions">
          <button
            type="button"
            className="quick-login-btn twitch"
            onClick={handleLogin}
            aria-label="Se connecter avec Twitch"
          >
            <FaTwitch />
            <span>Twitch</span>
          </button>
          <button
            type="button"
            className="quick-login-btn spotify"
            onClick={handleLogin}
            aria-label="Se connecter avec Spotify"
          >
            <FaSpotify />
            <span>Spotify</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default DisconnectedStatusCard;
